export default __webpack_public_path__ + "1a9b97c79f4826f3074871006d044e67.jpg";